/**
 * Placeholder per il catalogo in modalità mock.
 *
 * Niente file immagine spediti col frontend: il backend reale serve foto
 * vere via URL S3 firmati (vedi backend/lambdas/search), qui basta un
 * riquadro colorato distinguibile per elemento — generato al volo, zero
 * byte extra nella build.
 *
 * Volutamente sopra la pagina di ricerca (24): sotto quella soglia il "carica
 * altri" non scatterebbe mai in sviluppo, e un bug di paginazione passerebbe
 * inosservato finché non lo si vede contro il catalogo reale.
 */
const DEMO_IMAGE_COUNT = 41

function placeholderImage(index: number): string {
  const hue = (index * 47) % 360
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200">` +
    `<rect width="200" height="200" fill="hsl(${hue} 30% 84%)"/>` +
    `<rect width="200" height="200" fill="hsl(${hue} 25% 45%)" opacity="0.12"/>` +
    `</svg>`
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`
}

export const DEMO_IMAGES: string[] = Array.from({ length: DEMO_IMAGE_COUNT }, (_, index) =>
  placeholderImage(index),
)
